<template style="">
  <div class="Picture_release" v-loading="loading" element-loading-text="上传中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-form label-width="80px" style="padding-top: 20px;">
      <el-form-item label="公告标题">
        <el-input style="width: 300px;" v-model="MaterialName" placeholder="请输入公告标题（5-30个汉字）"></el-input>
      </el-form-item>

      <el-form-item label="上传封面" style="height: 180px;">
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"  accept=".jpg, .jpeg, .png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择文件</span>
          </i>
        </el-upload>
        <p style="margin-left: 240px;color: #606266;">请发布与网站主题相关的图片，图片大小需控制在500K以内 文件格式请用.jpg .png .jpeg  图片尺寸建议：300px*450px</p>
      </el-form-item>

      <el-form-item label="图片应用到轮播图">
        <el-switch v-model="AppHomepage"></el-switch> 
         <!-- RotatLanguage AppHomepage-->
      </el-form-item>

      <el-form-item label="语言">
        <el-radio-group v-model="RotatLanguage">
          <el-radio label="1">中</el-radio>
          <el-radio label="2">英</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="相关附件上传" prop="region">
        <el-upload :on-remove="handleRemove" action="" accept="" :auto-upload="false" :on-change="handleChanges" multiple :file-list="fileList2">
          <el-button class="video_btn iconfont icontianjia3">上传附件</el-button>
        </el-upload>
      </el-form-item>

      <!-- <el-form-item label="栏目">
        <el-cascader ref="wcascader" v-model="ItemKey" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable placeholder="请选择上级栏目"></el-cascader>
      </el-form-item>
  
      <el-form-item label="标签">
        <el-checkbox-group v-model="Label">
          <el-checkbox v-for="item in tagList" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->

      <el-form-item label="用途">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="Purpose"></el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input :rows="2" placeholder="请输入内容" v-model="LineNumber"></el-input>
      </el-form-item>

      <el-form-item label="是否启用">
        <el-switch :rows="2" v-model="delivery"></el-switch>
      </el-form-item>

      <!-- <el-form-item label="版权声明">
        <el-input type="textarea" :rows="2" placeholder="请输入内容" maxlength="200" v-model="CopyrightStatement"></el-input>
      </el-form-item> -->

      <el-form-item class="ue">
        <div class="editor-container">
          <UEtext :defaultMsg=defaultMsg ref="ue"></UEtext>
        </div>
      </el-form-item>

      <el-form-item style="padding-bottom: 30px;">
        <el-button type="primary" @click="onSubmit(1)">立即创建</el-button>
        <el-button type="primary" @click="onSubmit(2)">保存草稿</el-button>
      </el-form-item>
      
    </el-form>

    <el-dialog title="图片裁剪" :visible.sync="Croppdialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="closeCroppdialog" width="640px">
      <PictureCropper ref="picture" :initialImg="imageUrl" :cropperHeight="cropperHeight" :cropperWidth="cropperWidth" :autoCropWidth="autoCropWidth" :autoCropHeight="autoCropHeight" @picturePreview="picturePreview"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Croppdialog=false;">取 消</el-button>
        <el-button type="primary" @click="closeCroppdialog(2)">确 定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>
<script>
import UEtext from '@/components/text.vue';
import PictureCropper from '@/components/pictureCropper.vue'
export default {
  components: { UEtext,PictureCropper},
  data() {

    return {
      RotatLanguage:'',
      AppHomepage:true,
      fileList2: [],
      ruleFormfiles: [],
      Purpose: '',
      LineNumber: '',
      delivery: false,
      CopyrightStatement: '',
      data: [],
      loading:false,
      videopd:false,
      videourl: '',
      videoFile:"",//视频文件
      imageFile:"",//图片文件
      MaterialName: "",//视频标题
      Label: [],//标签
      ItemKey: "",//栏目
      img: "",
      imageUrl: '',
      tagList:[],//标签列表
      columnList: [],//栏目列表
      defaultMsg: '',

      // 裁剪
      Croppdialog:false,
      previews: {},
      cropperHeight: '600px',  // 裁剪图片容器高度
      cropperWidth: '600px',   // 裁剪图片容器宽度
      autoCropWidth: 200,
      autoCropHeight: 200
    }
  },
  mounted() {
    this.$Http_Post('management/tagList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.tagList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/columnList',).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.columnList = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

    this.$Http_Post('management/getColumnManagementByNode', { PItemKey: '0', pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })

  },
  methods: {
    picturePreview(data){
      this.previews = data
    },
    Selected_to_shut_dow(dt) {
      this.ItemKey = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    async download(){
      let aLink = document.createElement('a')
      aLink.download = '下载裁剪图片'
      let data = await this.$refs.picture.getBase64()
      aLink.href = data
      aLink.click()
    },

    // 确认裁剪并关闭弹窗
    async closeCroppdialog(e){
      this.Croppdialog=false;
      if(e==2){//确认裁剪并关闭
        this.imageUrl=await this.$refs.picture.getBase64();
        this.imageFile=await this.$refs.picture.getfile(this.imageUrl,Math.floor(new Date().getTime())+'.png');
      }
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].value == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].value != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {

      let obj = this.data[0];

      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].value == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].value != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }

      if (obj.fuzi && obj.children.length > 0 && obj.children[0].value == '-2') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/management/getColumnManagementByNode', { PItemKey: dt[dt.length - 1], pageIndex: "1", pageSize: "111110", Type: 1,RoleID:sessionStorage.getItem('RoleID')}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      }
      
    },

    handleRemove(file, fileList) {
      this.ruleFormfiles = [];
      if (fileList.length >= 2) {
        for (var i = 0; i < fileList.length; i++) {
          this.ruleFormfiles.push(fileList[i].raw);
        }

      } else {
        this.ruleFormfiles.push(fileList[0].raw);
      }
    },
    handleChanges(file, fileList) {
      if (fileList.length >= 2) {
        this.ruleFormfiles = [];
        for (var i = 0; i < fileList.length; i++) {
        this.ruleFormfiles.push(fileList[i].raw);
        }
      } else {
        this.ruleFormfiles.push(fileList[0].raw);
      }
    },

    onSubmit(type) {//创建
      console.log(this.ruleFormfiles)
      this.loading = true;
      var from = new FormData();
      from.append('fileName', this.imageFile);
      from.append('MaterialName', this.MaterialName);
      from.append('Label', this.Label);
      from.append('ItemKey', this.ItemKey);
      from.append('Type', type);
      from.append('Purpose', this.Purpose);
      from.append('LineNumber', this.LineNumber);      
      from.append('IsActive', this.delivery ? 1 : 0);
      from.append('CopyrightStatement', this.CopyrightStatement);
      from.append('CodeSnippet',this.$refs.ue.getUEContent());
      from.append('RotatLanguage', this.RotatLanguage);
      from.append('AppHomepage', this.AppHomepage?1:0);
      for(var i = 0; i<this.ruleFormfiles.length;i++){
        from.append('annexFile', this.ruleFormfiles[i]);
      }
      this.$Http_Post('management/NoticePublishing', from, { 'Content-Type': 'multipart/form-data', }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.videopd = true;
          this.loading = false;
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/propagate/index',
          })
        } else {
          this.loading = false;
          this.Global.request_failure(res.Message);
        }
      })

    },
    handleChange(file, fileList) {
      if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.imageFile = file;
        this.Croppdialog=true;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传图片' })
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    videohandleChange(file, fileList) {
      if (file.raw.type == 'audio/mpeg' || file.raw.type == 'audio/mp3' || file.raw.type == 'audio/wma' || file.raw.type == 'audio/wav' || file.raw.type == 'audio/amr' || file.raw.type == 'audio/m4a') {
        this.videoFile = file;
      } else {
        this.$message({ type: 'error', message: '文件格式错误，请上传音频' })
      }
    },
    videohandleAvatarSuccess(res, file) {},
    videobeforeAvatarUpload(file) {},
    //进度条
    uploadVideoProcess(event, file, fileList) {},
  },
}
</script>
<style>
  .Picture_release{background-color: #fff;width: 100%;}
  .avatar-uploader .el-upload:hover {border-color: #409eff;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 175px;}
  .avatar-uploader {position: absolute;top: 0px;left: 0px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
  .scale {margin-top: 30px;max-height: 333px;overflow: overlay;}
  .scale,.scale0 {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;max-height: 333px;overflow: overlay;}
  .Picture_release .el-textarea{width: 400px !important;}
  .Picture_release .el-input{width: 400px !important;}
  .editor-container{width: 750px;display: block;}
  .ue .el-form-item__content{line-height:1;}
  
</style>
